export default __webpack_public_path__ + "static/media/iread9.79812858.jpeg";